<template>
<div>
    <div class="mcc-page-header" >
        <div class="mu-d-flex mu-flex-column mu-w-100 mu-gap-02">
            <div class="mu-d-flex mu-justify-content-between mu-align-items-center mu-flex-nowrap">
                <section class="mu-d-flex">

                    <h1 class="mu-mb-00">File adapter</h1>
                    <details class="mcc-popover mcc-popover--bottom-end">
                        <summary class="mcc-button mcc-button--icon-only ">
                            <mcc-icon name="help" aria-hidden="true"></mcc-icon>
                        </summary>
                        <div class="mcc-popover__content">

                            <p class="mu-mb-00">
                                {{ helpText.title }}
                                <a :href="helpText.url" target="_blank">Read more...</a>
                            </p>
                        </div>
                    </details>
                </section>
                <section>
                    <div role="group" class="mcc-button-group" v-if="!newAdapter">
                        <button class="mcc-button mcc-button--outline" id="exportBtn" @click="exportFiles()" title="Export">
                            <mcc-icon name="export" aria-hidden="true"></mcc-icon><span class="mcc-button__label">Export</span>
                        </button>
                    </div>
                </section>
            </div>
        </div>
    </div>
    <div class="mcc-container-fluid card-padding">
        <div>
            <nav aria-label="breadcrumb" >
                <ol class="mcc-breadcrumb">
                    <li>Integrate</li>
                    <li>
                        <a class="table-link" @click="redirectToList()">External systems</a>
                    </li>
                    <li>
                        <router-link class="table-link" :to="CONTEXT_PATH + '/integrate/externalsystems/' + externalSystemId">{{externalSystem.name}}</router-link>
                    </li>
                    <li>
                        <a class="table-link" @click="redirectToFileAPI()">{{externalSystemAPI.name}}</a>
                    </li>
                    <li v-if="newAdapter" aria-current="page">Create new</li>
                    <li v-if="!newAdapter" aria-current="page">{{adapterName}}</li>

                    <li class="lastBredCrumpLi">
                    </li>
                </ol>
            </nav>
        </div>
        <div class="mcc-row" v-if="!fetchCall">
            <div class="mcc-col colSpinner">
                <div class="spinner-overlay">
                    <div class="spinner-background"></div>
                    <div class="spinner-flex">
                        <svg viewBox="0 0 50 50" class="mcc-spinner" animated="" style="width: 48px; height: 48px; ">
                            <circle class="mcc-spinner__track" cx="25" cy="25" r="20" fill="none" stroke-width="5"></circle>
                            <circle cx="25" cy="25" r="20" fill="none" stroke-width="5"></circle>
                        </svg>
                    </div>
                </div>
            </div>
        </div>
        <div class="mcc-card mu-p-06">
            <div>
                <div style="position:relative">
                    <div v-if="!updateCall" class="spinner-overlay">
                        <div class="spinner-background"></div>
                        <div class="spinner-flex">
                            <svg viewBox="0 0 50 50" class="mcc-spinner" animated="" style="width: 48px; height: 48px; ">
                                <circle class="mcc-spinner__track" cx="25" cy="25" r="20" fill="none" stroke-width="5"></circle>
                                <circle cx="25" cy="25" r="20" fill="none" stroke-width="5"></circle>
                            </svg>
                        </div>
                    </div>
                    <form novalidate id="adapterForm" @submit.prevent="saveFileAdpater()">
                    <div  v-if="fetchCall">

                        <div class="mcc-col mcc-col-xs-12 mcc-col-md-12 mcc-col-sm-12">
                            <mcc-alert role="alert" class="mcc-alert mcc-alert--warning mcc-alert--compact" id="externalSystemReadOnly" v-if="isReadOnly" >
                                <mcc-icon name="error" aria-hidden="true"></mcc-icon>
                                <p>
                                    <strong>Warning!</strong>
                                    <br />{{readOnlyMsg}}
                                    <br />
                                </p>
                            </mcc-alert>

                        </div>

        <div class="mcc-row">
            <div class="mcc-col mcc-col-12  mcc-col-md-6">
                          

                                <div class="mcc-card">
                                    <div class="mcc-card__header">
                                        <h2 class="mcc-card__title">Configuration</h2>
                                    </div>

                                    <div class="mcc-card__body">
                                        <div class="mcc-row">
                                            <div class="mcc-col">
                                                <div class="mfc-input-wrapper mu-d-block mfc-form-input-container ">
                                                    <label class="mfc-label--required" for="name">Name</label>
                                                    <input type="text" id="name" name="name" :value="dto.name" required="" placeholder="Name" maxlength="50" :disabled="isReadOnly" ref="name" :pattern="nameRegex" @change="updateName($event)">

                                                </div>
                                                <div class="mfc-input-wrapper mu-d-block mfc-form-input-container mu-mt-03">
                                                    <label class="mfc-label--required" for="fileName">File name</label>
                                                    <input type="text" id="fileName" :value="dto.fileName" name="fileName" required="" placeholder="File name" maxlength="50" :disabled="isReadOnly" ref="fileName" :pattern="filePathRegex" @change="updateFileName($event)">

                                                </div>
                                                <div class="mfc-textarea-wrapper mfc-form-input-container mu-mt-03">
                                                    <label for="content">Content</label>
                                                    <textarea id="content" name="content" maxlength="100000" :value="dto.content" placeholder="Content" :disabled="isReadOnly" @input="updateParams($event)" character-count=""></textarea>
                                                    <div class="mfc-invalid-feedback"></div>
                                                    <div class="mfc-help-text mu-mt-00">
                                                        
                                                        <span v-if="dto.content">You have {{100000 - dto.content.length}} characters remaining</span>
                                                        <span v-else>You have 100000 characters remaining</span>
                                                    </div>
                                                </div>
                                               
                                            </div>

                                        </div>

                                    </div>

                                </div>
                           

                        </div> 
                        <div class="mcc-col mcc-col-12  mcc-col-md-6">
                            <div class="mcc-card fullCardWidth">
                                <div class="mcc-card__header">
                                    <h2 class="mcc-card__title">Parameter types</h2>
                                </div>

                                <div class="mcc-card__body">
                                    <div>
                                        <div class="mcc-row" v-for="(item, index) in dto.fileParameterTypes" :key="index+item.fieldName">
                                            <div class="mcc-col">
                                                <div class="mfc-select-wrapper mu-d-block mfc-form-input-container mfc-form-input-wrapper--width">
                                                    <label class="mfc-label--required" :for="'fileParamsTypeCmp' + index">{{getLabel(item)}}</label>
                                                <select :disabled="isReadOnly" :id="'fileParamsTypeCmp' + index" @change="item.fieldType = $event.target.value"  help-text :data-value="item.fieldType">
                                                    <option :selected="item.fieldType === 'STRING'" value="STRING">String</option>
                                                    <option :selected="item.fieldType === 'BOOLEAN'" value="BOOLEAN">Boolean</option>
                                                    <option :selected="item.fieldType === 'DOUBLE'" value="DOUBLE">Double</option>
                                                    <option :selected="item.fieldType === 'FLOAT'" value="FLOAT">Float</option>
                                                    <option :selected="item.fieldType === 'INT'" value="INT">Int</option>
                                                    <option :selected="item.fieldType === 'LONG'" value="LONG">Long</option>
                                                    <option :selected="item.fieldType === 'DATE'" value="DATE">Date</option>
                                                    <option :selected="item.fieldType === 'TIME'" value="TIME">Time</option>
                                                    <option :selected="item.fieldType === 'TIMESTAMP'" value="TIMESTAMP">Timestamp</option>

                                                </select>
                                                </div>

                                            </div>
                                            <div class="mcc-col adapter-mandatory">
                                                <div class="mfc-checkbox-wrapper mfc-form-input-container" >
                                                    <input type="checkbox"  class="mfc-switch" :disabled="isReadOnly" :id="'fileParamsTypeCmpMandatory' + index" :name="'fileParamsTypeCmpMandatory' + index" :checked="item.mandatory" @change="item.mandatory = $event.target.checked">
                                                    <label :for="'fileParamsTypeCmpMandatory' + index">Mandatory</label>

                                                </div>

                                            </div>

                                        </div>
                                    </div>

                                </div>

                                </div>
                            </div>
                        </div>
                        </div>
                            <div class="mu-d-flex mu-justify-content-end mu-mt-05">
                                                <div class="mcc-button-group mcc-button-group--spaced mcc-button-group-flex-wrap">
                                                    <router-link v-if="newAdapter" :to="copyAdapter ? CONTEXT_PATH + '/integrate/externalsystems/' + externalSystemId+'/apis/'+externalSystemAPI.id + '/fileadapters/'+ copyAdapterId : CONTEXT_PATH + '/integrate/externalsystems/' + externalSystemId+'/apis/'+externalSystemAPI.id">
                                                        <button class="mcc-button mcc-button--outline mu-mr-05" id="cancelBtn" title="Cancel" type="button">
                                                            <mcc-icon name="cancel" aria-hidden="true"></mcc-icon><span class="mcc-button__label">Cancel</span>
                                                        </button>
                                                    </router-link>
                                                    <button class="mcc-button mcc-button--soft-danger" v-if="!newAdapter && !isReadOnly" id="deleteBtn" @click="showDeleteAdapterDialog()" title="Delete" type="button">
                                                        <mcc-icon name="trash" aria-hidden="true"></mcc-icon><span class="mcc-button__label">Delete</span>
                                                    </button>
                                                    <router-link v-if="!newAdapter && !isReadOnly" :to="CONTEXT_PATH + '/integrate/externalsystems/' + externalSystemId+'/apis/'+externalSystemAPI.id+'/fileadapters/new?copyAdapterId='+dto.id">

                                                        <button class="mcc-button mcc-button--outline mu-mr-05" id="copyBtn" title="Copy" type="button">
                                                            <mcc-icon name="copy" aria-hidden="true"></mcc-icon><span class="mcc-button__label">Copy</span>
                                                        </button>
                                                    </router-link>
                                                   
                                                    <button class="mcc-button mcc-button--success " v-if="!isReadOnly" id="saveBtn" title="Save" type="submit" >
                                                        <mcc-icon name="save" aria-hidden="true"></mcc-icon><span class="mcc-button__label">Save</span>
                                                    </button>
                                                </div>
                                            </div>
                                        </form>
                                        </div>
                    </div>
                </div>
            </div>
            
    
    <div class="mcc-dialog-overlay">
        <dialog class="mcc-dialog mcc-dialog--xs mcc-dialog--danger" v-if="dataLoaded" id="deleteFileAdapter" ref="deleteFileAdapterRef">
            <form novalidate>
                <section>
                    <div class="mcc-dialog__header">
                        <h2 class="h4" aria-label="Delete file adapter">Delete file adapter</h2>
                        <button type="button" class="mcc-button mcc-button--sm  mcc-button--ghost mcc-button--icon-only" @click="$refs.deleteFileAdapterRef.close()">
                        <mcc-icon name="close" aria-hidden="true"></mcc-icon>
                        <span class="mcc-button__label">Button</span>
                    </button>
                    </div>
                    <div class="mcc-dialog__body">
                        <div>
                            Are you sure you want to delete file adapter?</div>
                    </div>
                    <div class="mcc-dialog__footer">

                        <div class="mcc-button-group mcc-button-group--spaced">
                            <button type="button" class="mcc-button mcc-button--outline" @click="$refs.deleteFileAdapterRef.close()">No</button>
                            <button type="button" class="mcc-button mcc-button--danger" @click="deleteFileAdapter()">Yes</button>
                        </div>
                    </div>
                </section>
            </form>
        </dialog>
    </div>
</div>

</template>

<script>
import ExternalSystemAPI from "../../../services/ExternalSystemAPI";
import {
    EventBus
} from "../../../services/event-bus";
import constantMessages from "../../../messages";
import ImportExportAPI from "../../../services/ImportExportAPI";
import Utils from "@/script_utils";
import {
    handleFormValidation,
    validationMessages,
    displayErrorMessage
} from '../../../formvalid.js';

export default {
    name: "ExternalSystemAPICreate",
    data() {
        return {
            dto: {
                fileParameterTypes: []
            },
            adapterName: "",
            externalSystem: {},
            nameRegex: constantMessages.PATTERNS["name"],
            filePathRegex: constantMessages.PATTERNS["filePath"],
            externalSystemAPI: {},
            CONTEXT_PATH: process.env.VUE_APP_CONTEXT_PATH,
            helpText: constantMessages.BREADCRUMB_HELP["fileadapter.edit"],
            externalSystemId: this.$route.params.externalSystemId,
            apiId: this.$route.params.apiId,
            adapterId: this.$route.params.fileadapterid,
            copyAdapterId: this.$route.query.copyAdapterId,
            connectionType: [],
            showHelpText: false,
            fetchCall: true,
            updateCall: true,
            newAdapter: false,
            dataLoaded: false,
            copyAdapter: false,
            isReadOnly: false,
            readOnlyMsg: constantMessages.MESSAGES["error.externalsystems.readonly"],
            remainingCount: 100000,
        };
    },
    mounted() {
        Utils.applyFixedHeaderConfiguration(this);

        let self = this;
        self.fetchCall = false;

        let url =
            "/integrate/external-systems/" +
            self.externalSystemId +
            "/apis/" +
            self.apiId +
            "/fileadapters/" +
            self.adapterId;
        if (self.copyAdapterId != null) {
            self.newAdapter = true;
            self.copyAdapter = true;
            url =
                "/integrate/external-systems/" +
                self.externalSystemId +
                "/apis/" +
                self.apiId +
                "/fileadapters/" +
                self.copyAdapterId;
            self.helpText = constantMessages.BREADCRUMB_HELP["fileadapter.create"];
        } else if (self.adapterId == "new") {
            self.newAdapter = true;
            self.helpText = constantMessages.BREADCRUMB_HELP["fileadapter.create"];
            url =
                "/integrate/external-systems/" +
                self.externalSystemId +
                "/apis/" +
                self.apiId +
                "/fileadapters/api-info";
        }

        ExternalSystemAPI.getFileFileAdapterInfo(url)
            .then(result => {
                if (result == null || result == "") {
                    self.$router.push(self.CONTEXT_PATH + "/integrate/externalsystems");
                    EventBus.$emit("error-notification", {
                        msg: "Error while fetching external system Adapter"
                    });
                    return;
                }
                self.dataLoaded = true;
                self.externalSystem = result.externalSystemAPI.externalSystem;
                self.isReadOnly = self.externalSystem.readOnly;
                if (self.copyAdapter) {
                    result.fileApiAdapter.id = null;
                    result.fileApiAdapter.name = result.fileApiAdapter.name + "-" + "copy";
                    if (result.fileApiAdapter.name.length > 50) {
                        result.fileApiAdapter.name = result.fileApiAdapter.name.substring(0, 50);
                    }
                }
                self.externalSystemAPI = result.externalSystemAPI;
                self.dto = result.fileApiAdapter;
                if (self.copyAdapter) {
                    self.updateParamsCopy();
                }
                self.adapterName = self.dto.name;
                let pageTitle = constantMessages.PAGEHEADER_TITLE["menu.fileadapter.details"] + " - " + self.adapterName;
                if (self.newAdapter) {
                    pageTitle = constantMessages.PAGEHEADER_TITLE["menu.fileadapter.details"] + " - Create new";
                }
                EventBus.$emit("update-pageTitle", pageTitle);
            })
            .finally(function () {
                self.fetchCall = true;
            });
    },
    methods: {
        getLabel(item) {
            return (item.fieldName);
        },
        saveFileAdpater() {
            let self = this;
            let form = $('#adapterForm')

            if (!form[0].checkValidity()) {
                handleFormValidation(form, validationMessages);
                return;
            }
            self.updateCall = false;
            ExternalSystemAPI.saveFileAdpater(
                self.dto,
                self.externalSystemId,
                self.apiId
            ).then(response => {
                self.updateCall = true;
                if (response.error) {
                    for (let k in response.messages) {
                        if (k == "name") {
                            displayErrorMessage($(self.$refs.name), constantMessages.MESSAGES[response.messages[k]])
                            self.$refs.name.classList.add("ms-is-invalid")
                        } else if (k == "fileName") {
                            displayErrorMessage($(self.$refs.fileName), constantMessages.MESSAGES[response.messages[k]])
                            self.$refs.fileName.classList.add("ms-is-invalid")
                        }
                    }
                } else {
                    EventBus.$emit("success-notification", {
                        msg: constantMessages.MESSAGES[response.message]
                    });
                    self.adapterName = response.data.name;
                    if (self.newAdapter) {

                        this.$router
                            .push(
                                this.CONTEXT_PATH +
                                "/integrate/externalsystems/" +
                                self.externalSystem.id +
                                "/apis/" + self.apiId +
                                "/fileadapters/" + response.data.id
                            )
                    }
                }
            });
        },
        updateName(event) {
            let self = this;
            if (event.target.value == "") {
                displayErrorMessage($(self.$refs.name), constantMessages.MESSAGES["error.name.required"])
            } else if (event.target.value.length > 50) {
                displayErrorMessage($(self.$refs.name), constantMessages.MESSAGES["error.name.length"])
            } else {
                self.$refs.name.classList.remove("ms-is-invalid")

            }
            self.dto.name = event.target.value;
        },
        updateFileName(event) {
            let self = this;
            if (event.target.value == "") {
                displayErrorMessage($(self.$refs.fileName), constantMessages.MESSAGES["error.filename.required"])
            } else if (event.target.value.length > 50) {
                displayErrorMessage($(self.$refs.fileName), constantMessages.MESSAGES["error.filename.length"])
            } else {
                self.$refs.fileName.classList.remove("ms-is-invalid")

            }
            self.dto.fileName = event.target.value;
        },
        updateParamsCopy() {
            let self = this;
            let updatedFileParameterTypes = [];
            let existingParamTypes = self.dto.fileParameterTypes;
            if (existingParamTypes != null) {
                $.each(existingParamTypes, function (key, value) {
                    updatedFileParameterTypes.push({
                        "fieldName": value.fieldName,
                        "fieldType": value.fieldType,
                        "mandatory": value.mandatory,
                        "id": null,
                        "version": 0,
                        "deleted": null,
                        "fileApiAdapter": null
                    });

                });
            }
            self.dto.fileParameterTypes = updatedFileParameterTypes;

        },
        updateParams(event) {
            setTimeout(() => {
                let self = this;
                self.dto.content = event.target.value;
                let updatedFileParameterTypes = [];
                let existingParamTypes = self.dto.fileParameterTypes;
                self.dto.fileParameterTypes = [];
                let filetext = event.target.value;
                let re = /{{([^}]+)}}/g;
                let text;
                while (text = re.exec(filetext)) {
                    let type = "STRING";
                    let mandatory = false;
                    $.each(existingParamTypes, function (key, value) {
                        if (value.fieldName == text[1]) {
                            type = value.fieldType;
                            mandatory = value.mandatory;
                        }
                    });
                    updatedFileParameterTypes.push({
                        "fieldName": text[1],
                        "fieldType": type,
                        "mandatory": mandatory,
                        "id": null,
                        "version": 0,
                        "deleted": null,
                        "fileApiAdapter": null
                    });

                }

                self.dto.fileParameterTypes = updatedFileParameterTypes;

            }, 0);
        },
        deleteFileAdapter() {

            let self = this;
            self.updateCall = false;
            ExternalSystemAPI.deleteFileAdapter(
                self.externalSystemId,
                self.apiId,
                self.dto.id
            ).then(response => {
                self.updateCall = true;
                EventBus.$emit("success-notification", {
                    msg: "File adapter deleted successfully"
                });

                self.$router.push(self.CONTEXT_PATH + '/integrate/externalsystems/' + self.externalSystemId + '/apis/' + self.externalSystemAPI.id);
            });

        },
        redirectToFileAPI() {
            let self = this;
            localStorage.setItem("APIList", "APIList");

            self.$router.push(self.CONTEXT_PATH + '/integrate/externalsystems/' + self.externalSystemId + '/apis/' + self.externalSystemAPI.id);
        },
        exportFiles() {
            ImportExportAPI.exportFiles('FILEADAPTER', this.adapterId);
        },
        showDeleteAdapterDialog() {
            $("#deleteFileAdapter")[0].show();
        },
        redirectToList() {
            localStorage.setItem("externalSystemList", "externalSystemList");

            this.$router.push(
                this.CONTEXT_PATH + '/integrate/externalsystems'
            );
        },
    }
};
</script>
